import { registerAction } from '../../Action'

const REDUCE_POSTPLACEMENT = 'REDUCE_POSTPLACEMENT'

const reducer = (
  state = {},
  {
    payload: {
      content_id,
      placement_id,
      prev_placement_id = null,
      create = false,
    },
  }
) => {
  const placements = state.jsonApiEntities.placement
  const contents = state.jsonApiEntities.content
  const placement = { id: placement_id, type: 'placement' }
  const content = { id: content_id, type: 'content' }

  // Assign PostPlacement
  if (create) {
    contents[content_id].relationships.placement = placement
    placements[placement_id].relationships.posts.push(content)

    return {
      ...state,
      content: { ...content },
      placement: { ...placements },
    }
  }

  // Update PostPlacement
  if (prev_placement_id !== null) {
    const prev = placements[prev_placement_id]
    if (prev.relationships && prev.relationships.posts) {
      prev.relationships.posts = prev.relationships.posts.filter(
        (post) => post.id !== content_id
      )
    }
    contents[content_id].relationships.placement = placement
    placements[placement_id].relationships.posts.push(content)

    return {
      ...state,
      content: { ...content },
      placement: { ...placements },
    }
  }

  // Delete PostPlacement
  const current = placements[placement_id]
  if (current && current.relationships && current.relationships.posts) {
    current.relationships.posts = current.relationships.posts.filter(
      (post) => post.id !== content_id
    )
  }
  if (contents[content_id].placement) contents[content_id].placement = null
  if (contents[content_id].relationships.placement)
    contents[content_id].relationships.placement = null

  return {
    ...state,
    content: { ...content },
    placement: { ...placements },
  }
}

const reducePostPlacement = registerAction(REDUCE_POSTPLACEMENT, { reducer })

export default reducePostPlacement
